import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female',
	additionalCrmLinks: [
		{
			name: 'Link to Paywall (short plans)',
			routeName: 'plan-email-female',
		},
	],
	landing: {
		ids: ['loader-f'],
		route: {
			path: '/f',
			name: 'female-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'female_funnel', // /f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female'],
			},
			{
				matcher: {
					utm_term: /bellytype/,
				},
				ids: ['creatives-bellytype'],
			},
			{
				matcher: {
					$or: {
						utm_content: /excel/,
						utm_term: /excel/,
					},
				},
				ids: ['creatives-spreadsheet'],
			},
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female'],
			},
		],
	},
	funnel: {
		id: 'ob-female-funnel',
		route: {
			path: '/f/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-survey',
		},
		slug: 'female',
		theme: 'light',
		locale: [
			'en',
			'de-DE',
			'fr-FR',
			'tr',
			'sv',
			'pl',
			'pt-BR',
			'it-IT',
			'es-ES',
			'es-419',
			'da',
			'nb',
			'nl',
			'ar',
			'ja',
		],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-f',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
